import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  bg: {
    fill: '#1a2b4c',
  },
  text: {
    fill: '#5ec8d8',
    fontFamily: 'Helvetica, Arial, sans-serif',
    fontWeight: 700,
    fontSize: 22,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
    >
      <rect className={classes.bg} x="0" y="0" width="40" height="40" rx="8" />
      <text x="7" y="27" className={classes.text}>
        SC
      </text>
    </svg>
  );
};
